import React, { useState, useEffect } from "react";
import { useForm, FormProvider } from "react-hook-form";
//Material
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
//Component
import { Modal } from "../../stories/modal";
import FormInput from "../../stories/hook-controls/input";
import { ReactTable } from "../../stories/react-table";
//Function
import { setDataToFormHookV2,isEmptyStr } from "../../utils/common-function";
import { formatDateTime } from "./../../utils/common-function"
import { getDetailUpload } from "./columns/view-history";
import { TextField, Divider } from "@material-ui/core";

function ViewUpload(props) {
    const { open } = props;
    const { Detail, ...otherprops } = props;

    const method = useForm();
    const { setValue } = method;
    const [columns, setColumns] = useState([]);

    useEffect(() => {
        if (!open) return;
        if(typeof Detail === "undefined") return;

        Detail.UploadDate = formatDateTime(Detail.UploadDate);
        let data = setDataToFormHookV2(Detail);
        setColumns(Detail.listColumn)
        setTimeout(() => data?.forEach(({ name, value }) => setValue(name, value)));
      }, [Detail, setValue, open]);

    return (
      <Modal
        {...otherprops}
        hiddenSave={true}
        title="View Column Upload"
        maxWidth="lg"
      >
        <FormProvider {...method}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Box flexGrow={1} className="box-input">
                <FormInput
                  InputProps={{
                    readOnly: true,
                  }}
                  variant="filled"
                  name="LoadID"
                  label="Load ID"
                />
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box flexGrow={1} className="box-input">
                <FormInput
                  InputProps={{
                    readOnly: true,
                  }}
                  variant="filled"
                  name="LoadTopic"
                  label="Load Topic"
                />
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box flexGrow={1} className="box-input">
                <FormInput
                  InputProps={{
                    readOnly: true,
                  }}
                  variant="filled"
                  name="LoadStatus"
                  label="Status"
                />
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box flexGrow={1} className="box-input">
                <FormInput
                  InputProps={{
                    readOnly: true,
                  }}
                  variant="filled"
                  name="HOST_NAME"
                  label="Host Name"
                />
              </Box>
            </Grid>
            <Grid item xs={12}>
            <Box flexGrow={1} className="box-input">
              <TextField
                id="outlined-textarea"
                name="ErrorMessage"
                label="ERROR MESSAGE "
                multiline
                variant="filled"
                rows={10}
                fullWidth
                disabled={true}
                value={Detail?.ErrorMessage ?? ""}
              />
            </Box>
          </Grid>
            <Grid item xs={12}>
              <Box flexGrow={1} className="box-input">
                <FormInput
                  InputProps={{
                    readOnly: true,
                  }}
                  variant="filled"
                  name="UploadDate"
                  label="Upload Date"
                />
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box flexGrow={1} className="box-input">
              <ReactTable
              otherprops
              keyField="ColumnName"
              data={columns}
              columns={getDetailUpload()}
              showSearch={false}
            />
              </Box>
            </Grid>
            {/* {columns?.map((el) => (
              <Box key={el.ColumnName} display="flex" justifyContent="center">
                <Grid item xs={12} key={el.ColumnName}>
                  <Box flexGrow={1} className="box-input">
                    <FormInput
                      InputProps={{
                        readOnly: true,
                      }}
                      variant="filled"
                      name={el.ColumnName}
                      label={"Column"}
                      value={el.ColumnName}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} key={"Encrypt_" + el.ColumnName}>
                  <Box flexGrow={1} className="box-input">
                    <FormInput
                      InputProps={{
                        readOnly: true,
                      }}
                      variant="filled"
                      name={"Encrypt_" + el.ColumnName}
                      label={"Encrypt"}
                      value={el.Encrypt}
                    />
                  </Box>
                </Grid>
              </Box>
            ))} */}
            
          </Grid>
        </FormProvider>
      </Modal>
    );
}
export default ViewUpload;
